export default{
    proveedores: [],
    proveedorSelec: null,
}